import cx from 'classnames';
import React from 'react';

import styles from './MeetingStageContainer.module.scss';

export const MeetingStageContainer = React.forwardRef<
    HTMLDivElement,
    {
        children: React.ReactNode;
        className?: string;
        isHorizontal?: boolean;
        isPrimaryVideoExpanded?: boolean;
        isSidePanelVisible?: boolean;
        noMargin?: boolean;
    }
>(
    (
        {
            children,
            className,
            isHorizontal,
            isPrimaryVideoExpanded,
            isSidePanelVisible,
            noMargin,
            ...props
        },
        ref,
    ) => {
        return (
            <div
                className={cx(styles.container, className, {
                    [styles.horizontal]: !!isHorizontal,
                    [styles.withSidePanel]: !!isSidePanelVisible && !noMargin,
                    [styles.expanded]: !!isPrimaryVideoExpanded,
                    [styles.noMargin]: !!noMargin,
                })}
                {...props}
                ref={ref}
            >
                {children}
            </div>
        );
    },
);

MeetingStageContainer.displayName = 'MeetingStageContainer';

export type MeetingStageContainerProps = React.ComponentProps<
    typeof MeetingStageContainer
>;
